import { formStoreLenses } from 'root/src/client/logic/form/lenses'

const { viewSubmitsLoading } = formStoreLenses

export default (state, { moduleId }) => viewSubmitsLoading(moduleId, state)
